/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PCodeRouteImport } from './routes/p/$code'
import { Route as LeadExpiredRouteImport } from './routes/lead/expired'
import { Route as LeadIdRouteImport } from './routes/lead/$id'
import { Route as BookingExpiredRouteImport } from './routes/booking/expired'
import { Route as BookingIdRouteImport } from './routes/booking/$id'
import { Route as BookingIdQuestionnaireRouteImport } from './routes/booking/$id_.questionnaire'
import { Route as BookingIdProcessingRouteImport } from './routes/booking/$id_.processing'
import { Route as BookingIdCheckoutRouteImport } from './routes/booking/$id_.checkout'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PCodeRoute = PCodeRouteImport.update({
  id: '/p/$code',
  path: '/p/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadExpiredRoute = LeadExpiredRouteImport.update({
  id: '/lead/expired',
  path: '/lead/expired',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadIdRoute = LeadIdRouteImport.update({
  id: '/lead/$id',
  path: '/lead/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingExpiredRoute = BookingExpiredRouteImport.update({
  id: '/booking/expired',
  path: '/booking/expired',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIdRoute = BookingIdRouteImport.update({
  id: '/booking/$id',
  path: '/booking/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIdQuestionnaireRoute = BookingIdQuestionnaireRouteImport.update({
  id: '/booking/$id/questionnaire',
  path: '/booking/$id/questionnaire',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIdProcessingRoute = BookingIdProcessingRouteImport.update({
  id: '/booking/$id/processing',
  path: '/booking/$id/processing',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIdCheckoutRoute = BookingIdCheckoutRouteImport.update({
  id: '/booking/$id/checkout',
  path: '/booking/$id/checkout',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/booking/$id': typeof BookingIdRoute
  '/booking/expired': typeof BookingExpiredRoute
  '/lead/$id': typeof LeadIdRoute
  '/lead/expired': typeof LeadExpiredRoute
  '/p/$code': typeof PCodeRoute
  '/booking/$id/checkout': typeof BookingIdCheckoutRoute
  '/booking/$id/processing': typeof BookingIdProcessingRoute
  '/booking/$id/questionnaire': typeof BookingIdQuestionnaireRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/booking/$id': typeof BookingIdRoute
  '/booking/expired': typeof BookingExpiredRoute
  '/lead/$id': typeof LeadIdRoute
  '/lead/expired': typeof LeadExpiredRoute
  '/p/$code': typeof PCodeRoute
  '/booking/$id/checkout': typeof BookingIdCheckoutRoute
  '/booking/$id/processing': typeof BookingIdProcessingRoute
  '/booking/$id/questionnaire': typeof BookingIdQuestionnaireRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/booking/$id': typeof BookingIdRoute
  '/booking/expired': typeof BookingExpiredRoute
  '/lead/$id': typeof LeadIdRoute
  '/lead/expired': typeof LeadExpiredRoute
  '/p/$code': typeof PCodeRoute
  '/booking/$id/checkout': typeof BookingIdCheckoutRoute
  '/booking/$id/processing': typeof BookingIdProcessingRoute
  '/booking/$id/questionnaire': typeof BookingIdQuestionnaireRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/booking/$id'
    | '/booking/expired'
    | '/lead/$id'
    | '/lead/expired'
    | '/p/$code'
    | '/booking/$id/checkout'
    | '/booking/$id/processing'
    | '/booking/$id/questionnaire'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/booking/$id'
    | '/booking/expired'
    | '/lead/$id'
    | '/lead/expired'
    | '/p/$code'
    | '/booking/$id/checkout'
    | '/booking/$id/processing'
    | '/booking/$id/questionnaire'
  id:
    | '__root__'
    | '/'
    | '/booking/$id'
    | '/booking/expired'
    | '/lead/$id'
    | '/lead/expired'
    | '/p/$code'
    | '/booking/$id/checkout'
    | '/booking/$id/processing'
    | '/booking/$id/questionnaire'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BookingIdRoute: typeof BookingIdRoute
  BookingExpiredRoute: typeof BookingExpiredRoute
  LeadIdRoute: typeof LeadIdRoute
  LeadExpiredRoute: typeof LeadExpiredRoute
  PCodeRoute: typeof PCodeRoute
  BookingIdCheckoutRoute: typeof BookingIdCheckoutRoute
  BookingIdProcessingRoute: typeof BookingIdProcessingRoute
  BookingIdQuestionnaireRoute: typeof BookingIdQuestionnaireRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$code': {
      id: '/p/$code'
      path: '/p/$code'
      fullPath: '/p/$code'
      preLoaderRoute: typeof PCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lead/expired': {
      id: '/lead/expired'
      path: '/lead/expired'
      fullPath: '/lead/expired'
      preLoaderRoute: typeof LeadExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lead/$id': {
      id: '/lead/$id'
      path: '/lead/$id'
      fullPath: '/lead/$id'
      preLoaderRoute: typeof LeadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/expired': {
      id: '/booking/expired'
      path: '/booking/expired'
      fullPath: '/booking/expired'
      preLoaderRoute: typeof BookingExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$id': {
      id: '/booking/$id'
      path: '/booking/$id'
      fullPath: '/booking/$id'
      preLoaderRoute: typeof BookingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$id/questionnaire': {
      id: '/booking/$id/questionnaire'
      path: '/booking/$id/questionnaire'
      fullPath: '/booking/$id/questionnaire'
      preLoaderRoute: typeof BookingIdQuestionnaireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$id/processing': {
      id: '/booking/$id/processing'
      path: '/booking/$id/processing'
      fullPath: '/booking/$id/processing'
      preLoaderRoute: typeof BookingIdProcessingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$id/checkout': {
      id: '/booking/$id/checkout'
      path: '/booking/$id/checkout'
      fullPath: '/booking/$id/checkout'
      preLoaderRoute: typeof BookingIdCheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BookingIdRoute: BookingIdRoute,
  BookingExpiredRoute: BookingExpiredRoute,
  LeadIdRoute: LeadIdRoute,
  LeadExpiredRoute: LeadExpiredRoute,
  PCodeRoute: PCodeRoute,
  BookingIdCheckoutRoute: BookingIdCheckoutRoute,
  BookingIdProcessingRoute: BookingIdProcessingRoute,
  BookingIdQuestionnaireRoute: BookingIdQuestionnaireRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
